import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const main = () => import('../views/main')
const products = () => import('../views/products')
const aboutUs = () => import('../views/aboutUs')
const contactUs = () => import('../views/contactUs')
const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    redirect: "/home"
  },
  {
    path: '/home',
    component: HomePage,
    children: [
      { path: "", redirect: "main" },
      { path: "main", component: main },
      { path: "products", component: products },
      { path: "about-us", component: aboutUs },
      { path: "contact-us", component: contactUs }
    ]
  }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js